import { render, staticRenderFns } from "./DetailText.vue?vue&type=template&id=001ceb38&scoped=true&"
import script from "./DetailText.vue?vue&type=script&lang=js&"
export * from "./DetailText.vue?vue&type=script&lang=js&"
import style0 from "./DetailText.vue?vue&type=style&index=0&id=001ceb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ceb38",
  null
  
)

export default component.exports